Vue.component('read-more', {
    template: `
    <div class="read-more">

        <span v-html="formattedString" class="popoverDescription"></span>
		<span v-show="text.length > maxChars">
			<a class="readmore" v-show="!isReadMore" @click="triggerReadMore($event, true)">{{moreStr}}</a>
			<a class="readless" v-show="isReadMore" @click="triggerReadMore($event, false)">{{lessStr}}</a>
		</span>

    </div>
    `,

    data: function() {
        return {
            moreStr: 'Read more',
            lessStr: 'Less',
            maxChars: 100,
            isReadMore: false
        };
    },

    mounted() {
        EventBus.$on('new_class', () => {
                this.isReadMore = false;
        })
    },

    props: {
        text: {
            type: String,
            required: true
        }
    },

    computed: {
        formattedString(){
			var val_container = this.text;

			if(!this.isReadMore && this.text.length > this.maxChars){
				val_container = val_container.substring(0,this.maxChars) + '...';
			}

			return(val_container);
		}
    },

    methods: {

        triggerReadMore(e, b){
			e.preventDefault();

			if(this.lessStr !== null || this.lessStr !== '')
				this.isReadMore = b;
		}

    }
});
